<div class="outer-container">
    <img class="icon" [src]="modalData.icon">
    <div class="content">{{modalData.content | translate}}</div>
    <div class="buttons-container">
        <button class="primary-button cursor-pointer" (click)="confirmClick()">{{modalData.btnText1 | translate}}</button>
        <button class="secondary-button cursor-pointer" (click)="cancelClick()">{{modalData.btnText2 | translate}}</button>
    </div>
</div>
